import createVueApp from '@/common/createApp'

// Styxie derives the name from Admin::Moments::VoicesController → AdminMomentsVoices,
// and every key is a controller action. A key that does not match the action renders
// the page chrome and never mounts Vue, with no error anywhere — hence the spec.
Styxie.Initializers.AdminMomentsVoices = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/moments/voices/index.vue')
    createVueApp(IndexPage, { props })
  },
  new: async(props) => {
    const { default: NewPage } = await import('@/vue_widgets/admin/moments/voices/new.vue')
    createVueApp(NewPage, { props })
  },
  edit: async(props) => {
    const { default: EditPage } = await import('@/vue_widgets/admin/moments/voices/edit.vue')
    createVueApp(EditPage, { props })
  }
}
